import React, { useEffect, useMemo, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import MyTable from '../../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

//Redux
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom'
import allActions from "../../../../../actions";

// Utils
import { isEmpty } from 'lodash';
import moment from 'moment';
import { getConsultingId } from "../../../../utils/utils";
import { ClickAwayListener, Grow, IconButton, Menu, MenuItem, MenuList, Paper, Popper, Tooltip, Typography } from "@material-ui/core";
import { unoTheme } from "../../../../../assets/styles/unoTheme";

import { doGetStatusDpinClientsByYearRange } from "../../../../../controllers/ClientController";

import SearchBar from "../../../../utils/SearchBar";
import { StatusDpinDairAPI } from "../../../../../API/status_dpin_dair";
import { path } from "../../../../utils/routesPaths";
import { ClientAPI } from "../../../../../API/client";

import CommentIcon from '@material-ui/icons/Comment';
import SortIcon from '@material-ui/icons/Sort';
import { classificationsMap } from '../../../backOffice/NewClientScreen';

const YEARS_COUNT = 10;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },

    dpinColumn: {
        background: '#fdffe0 !important',
        borderBottom: 'solid 0.2px #efefef !important',
        '&.MuiTableCell-body': {
            cursor: "pointer",
            '&:hover': {
                background: '#fbffc7 !important',
            }
        }
    },

    commentIcon: {
        cursor: "pointer",
        color: unoTheme.mainGrayColor,

        '&:hover': {
            color: unoTheme.mainColor,
        }
    },

    hoverHeader: {
        cursor: "pointer",
        '&:hover': {
            color: unoTheme.mainColor + " !important",
        }
    },
}));

export default function DpinTab(props) {

    const { selectedYearClosure, selectedDpinFilter, selectedAdvisor } = props;

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const currentUser = useSelector(state => state.currentUser)

    //A partir de 01/10 do ano corrente, o ano seguinte passa a ser exibido (janela fixa de YEARS_COUNT anos)
    const selectedYearInt = parseInt(selectedYearClosure);
    const today = moment();
    const showNextYear = selectedYearInt === today.year() && today.month() >= 9; //outubro = 9
    const endYear = showNextYear ? selectedYearInt + 1 : selectedYearInt;

    //Anos exibidos: do mais recente (endYear) à esquerda até o mais antigo à direita
    const years = [];
    for (let i = 0; i < YEARS_COUNT; i++) {
        years.push(endYear - i);
    }

    const [statusesDpin, setStatusesDpin] = useState(null);

    //Apenas os status ativos podem ser escolhidos pelo usuário; a lista completa segue
    //sendo usada para exibir os registros já gravados
    const activeStatusesDpin = useMemo(() => (statusesDpin || []).filter(el => el.active !== false), [statusesDpin]);

    const [statusClientsArray, setStatusClientsArray] = useState(null);
    const [search, setSearch] = useState("");

    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(1);

    const [sortOrder, setSortOrder] = useState('alpha_asc');
    const [sortMenuAnchor, setSortMenuAnchor] = useState(null);

    const LIMIT = 30;

    //Popper troca de status
    const [openChangeStatusMenuDpin, setOpenChangeStatusMenuDpin] = useState(false);
    const anchorRef = React.useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedClientInfo, setSelectedClientInfo] = useState(null);

    async function loadStatusesDpin() {
        const response = await StatusDpinDairAPI.getStatusesDpin();
        if (response.success) {
            setStatusesDpin(response.body.rows);
        }
    }

    async function loadDpinClients(page, year, search) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Carregando clientes...'
        }));

        setStatusClientsArray(null);
        const offset = (page - 1) * LIMIT;

        const advisorToFilter = selectedAdvisor && selectedAdvisor.id ? selectedAdvisor.id : null;

        const response = await doGetStatusDpinClientsByYearRange(
            offset,
            advisorToFilter == null && isEmpty(search) && !selectedDpinFilter ? LIMIT : 'NO_PAGINATION',
            year,
            advisorToFilter,
            getConsultingId(currentUser),
            search,
            sortOrder,
            endYear - (YEARS_COUNT - 1),
            endYear
        );

        if (response.success && response.body && response.body.length) {
            setStatusClientsArray(response.body);
            setTotalItems(response.totalItems);
            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: false,
            }));
        } else {
            setStatusClientsArray(null);
            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                emptyMessage: "Nenhum cliente encontrado",
            }));
        }
    }

    const handleChange = (value) => {
        const newPage = page + value;
        setPage(newPage);
        loadDpinClients(newPage, selectedYearClosure, search);
    };

    const handleToggleDpin = () => {
        setOpenChangeStatusMenuDpin((prevOpen) => !prevOpen);
    };

    const handleCloseDpin = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpenChangeStatusMenuDpin(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenChangeStatusMenuDpin(false);
        }
    }

    function openChangeStatusDpin(target, year, selectedClient) {
        setSelectedClientInfo({
            client: selectedClient,
            year: year
        })
        handleToggleDpin();
        setAnchorEl(target);
    }

    async function doChangeStatusDpin(infoClient, statusSelected) {

        handleCloseDpin();
        const response = await StatusDpinDairAPI.changeStatusDpin(statusSelected.id,
            infoClient.client.id,
            currentUser.user.id,
            infoClient.year);

        if (response.success) {
            updateViewStatusDpinClient(infoClient.client.id, infoClient.year, statusSelected)
        }
    }

    function updateViewStatusDpinClient(clientId, year, newStatus) {
        const newValuesStatusClientsArray = [...statusClientsArray];

        const clientToChange = newValuesStatusClientsArray.find(el => el.id == clientId);

        if (clientToChange) {
            if (!clientToChange.dpinByYear) clientToChange.dpinByYear = {};
            clientToChange.dpinByYear[year] = {
                status_dpin_id: newStatus.id,
                dpin_name: newStatus.name,
                dpin_short_name: newStatus.short_name,
                dpin_color: newStatus.color,
            };

            setStatusClientsArray(newValuesStatusClientsArray);
        }
    }

    function renderMenuChangeStatusDpin(items) {

        const menuList = [];

        items.forEach(item => {
            menuList.push(<MenuItem
                key={'menu-dpin-' + item.id}
                onClick={() => doChangeStatusDpin(selectedClientInfo, item)}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{
                        backgroundColor: item.color,
                        width: '8px',
                        height: '8px',
                        marginRight: '6px',
                        borderRadius: '50%'
                    }}></div><Typography style={{ fontSize: '10px' }}>{item.short_name} - {item.name}</Typography>
                </div>
            </MenuItem >);
        });

        return menuList;
    }

    //Retorna as informações de exibição do status DPIN de um cliente para um ano específico
    function getDpinInfoForYear(clientRow, year) {

        //Ano anterior ao início da carteira do cliente: não aplicável
        if (clientRow.initYear && year < clientRow.initYear) {
            return { name: '', shortName: '-', color: '', statusId: null, clickable: false };
        }

        const dpinRec = clientRow.dpinByYear ? clientRow.dpinByYear[year] : null;

        if (dpinRec == null && year <= 2022) {
            const lastStatusDpin = statusesDpin[11]; //REGULAR
            return { name: lastStatusDpin.name, shortName: lastStatusDpin.short_name, color: lastStatusDpin.color, statusId: lastStatusDpin.id, clickable: true };
        } else if (dpinRec == null && year > 2022) {
            const lastStatusDpin = statusesDpin[0]; //INFORMAÇÕES PENDENTES
            return { name: lastStatusDpin.name, shortName: lastStatusDpin.short_name, color: lastStatusDpin.color, statusId: lastStatusDpin.id, clickable: true };
        } else {
            return { name: dpinRec.dpin_name, shortName: dpinRec.dpin_short_name, color: dpinRec.dpin_color, statusId: dpinRec.status_dpin_id, clickable: true };
        }
    }

    function renderColumnsStatus(clientRow) {

        const columnsClient = [];

        years.forEach((year) => {

            const info = getDpinInfoForYear(clientRow, year);

            columnsClient.push(
                <TableCell
                    key={'status-dpin-' + clientRow.id + '-' + year}
                    className={classes.dpinColumn}
                    onClick={(e) => info.clickable
                        ? openChangeStatusDpin(e.currentTarget, year, clientRow)
                        : null}
                    align="center"
                    style={info.clickable ? {} : { pointerEvents: 'none' }}>
                    <Tooltip button
                        title={info.name}
                        enterDelay={200}
                        leaveDelay={100}
                        placement="bottom"
                        arrow>
                        <div style={{
                            fontWeight: '600',
                            fontSize: '10px',
                            letterSpacing: '1px',
                            color: info.color,
                        }}>{info.shortName}</div>
                    </Tooltip>
                </TableCell>
            );
        });

        //Coluna final de status, relativa ao último ano (selectedYearClosure)
        const lastYearInfo = getDpinInfoForYear(clientRow, parseInt(selectedYearClosure));
        const isOk = Number(lastYearInfo.statusId) === 10 || Number(lastYearInfo.statusId) === 11;

        columnsClient.push(
            <TableCell
                key={'status-final-' + clientRow.id}
                align="center">
                <Tooltip button
                    title={isOk ? 'OK' : 'NÃO OK'}
                    enterDelay={200}
                    leaveDelay={100}
                    placement="bottom"
                    arrow>
                    <div style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        margin: '0 auto',
                        backgroundColor: isOk ? unoTheme.greenMoney : unoTheme.redMoney,
                    }} />
                </Tooltip>
            </TableCell>
        );

        return columnsClient;
    }

    function handleOpenTotalizer(year) {
        dispatch(allActions.rightContentActions.setRightContent({
            path: "statusesClientsByMonth",
            data: {
                isDPIN: true,
                year: year,
                advisorId: selectedAdvisor && selectedAdvisor.id,
                consultingId: getConsultingId(currentUser),
                search: search,
                dairStatusIdFilter: null,
                monthFilterDair: null,
                dpinStatusIdFilter: selectedDpinFilter && selectedDpinFilter.id,
                snapshotDate: null,
            }
        }))
    }

    async function detailClient(clientId) {

        const clientSelected = await ClientAPI.getClientById(clientId);

        if (clientSelected.success) {
            history.push(
                {
                    pathname: path.administration.client.details.newClient,
                    state: { client: clientSelected.body }
                }
            )
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao carregar cliente",
                type: 'error',
            }));
        }
    }

    useEffect(() => {
        loadStatusesDpin();
    }, []);

    useEffect(() => {
        setPage(1);
        loadDpinClients(1, selectedYearClosure, search);
    }, [selectedYearClosure, search, selectedDpinFilter, selectedAdvisor, sortOrder]);

    //Filtro por status DPIN do ano selecionado (selectedYearClosure)
    const displayedClients = (statusClientsArray && selectedDpinFilter && statusesDpin)
        ? statusClientsArray.filter(row => getDpinInfoForYear(row, parseInt(selectedYearClosure)).statusId == selectedDpinFilter.id)
        : statusClientsArray;

    return (
        <div className={classes.root}>

            <div class={'defaultScrollWithHeaderContent'}>

                <MyTable
                    pagination={
                        isEmpty(search) &&
                        !selectedDpinFilter &&
                        (selectedAdvisor == null || selectedAdvisor.id == null) &&
                        statusClientsArray
                        && statusClientsArray.length > 0
                    }
                    itemspage={LIMIT}
                    totalitems={totalItems}
                    currentPage={page}
                    handlePage={handleChange}
                    stickyHeader
                    withBorderColumn
                    size="small">
                    <colgroup>
                        <col width="20%" />
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                align="left"
                                style={{ paddingLeft: '0px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <SearchBar
                                        name='search_query'
                                        mask='text_cnpj'
                                        size='small'
                                        spacingRight
                                        variant='outlined'
                                        label='Cliente'
                                        setSearchQuery={setSearch}
                                    />
                                    <Tooltip title="Ordenação" placement="top" arrow>
                                        <IconButton size="small" onClick={(e) => setSortMenuAnchor(e.currentTarget)}>
                                            <SortIcon style={{ color: sortOrder !== 'alpha_asc' ? '#1976d2' : undefined }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </TableCell>
                            {years.map((year) => (
                                <TableCell
                                    key={'header-dpin-year-' + year}
                                    className={classes.hoverHeader}
                                    align="center"
                                    onClick={() => handleOpenTotalizer(year)}>{year}</TableCell>
                            ))}
                            <TableCell align="center">Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {statusesDpin && displayedClients
                            && displayedClients.map((row) => (
                                <TableRow
                                    key={'status-dpin-client-' + row.id}>
                                    <TableCell
                                        onClick={() => detailClient(row.id)}
                                        align="left">
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div>{row.label_name}</div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                {row.classification && (
                                                    <div style={{
                                                        borderRadius: '4px',
                                                        background: classificationsMap[row.classification]?.color,
                                                        padding: '1px 6px',
                                                        fontSize: '10px',
                                                        color: '#fff',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                    }}>
                                                        {row.classification}
                                                    </div>
                                                )}
                                                <CommentIcon className={classes.commentIcon}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        dispatch(allActions.rightContentActions.setRightContent({
                                                            path: 'statusesClientHistoricDpin',
                                                            data: {
                                                                year: selectedYearClosure,
                                                                clientId: row.id,
                                                            }
                                                        }))
                                                    }} />
                                            </div>
                                        </div>
                                    </TableCell>
                                    {renderColumnsStatus(row)}
                                </TableRow>
                            ))}
                    </TableBody>
                </MyTable>
            </div>

            <Popper
                open={openChangeStatusMenuDpin}
                anchorEl={anchorEl}
                transition
                disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleCloseDpin}>
                                {openChangeStatusMenuDpin ?
                                    <div>
                                        <Typography style={{ fontSize: '12px', padding: '8px', borderBottom: 'solid 1px #eeeeee' }}>{selectedClientInfo && (selectedClientInfo.client.label_name + ' (' + selectedClientInfo.year + ")")}</Typography>

                                        <MenuList style={{ maxHeight: '150px', overflowY: 'scroll' }} autoFocusItem={openChangeStatusMenuDpin} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                            {renderMenuChangeStatusDpin(activeStatusesDpin)}
                                        </MenuList>

                                    </div> : <div></div>
                                }
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

            <Menu
                id="sort-order-menu-dpin"
                anchorEl={sortMenuAnchor}
                keepMounted
                open={Boolean(sortMenuAnchor)}
                onClose={() => setSortMenuAnchor(null)}>
                {[
                    { value: 'priority_desc', label: 'Ordenar por prioridade Desc' },
                    { value: 'priority_asc', label: 'Ordenar por prioridade Asc' },
                    { value: 'alpha_asc', label: 'Ordenar Alfabética Asc' },
                    { value: 'alpha_desc', label: 'Ordenar Alfabética Desc' },
                ].map(opt => (
                    <MenuItem
                        key={opt.value}
                        selected={sortOrder === opt.value}
                        onClick={() => { setSortOrder(opt.value); setSortMenuAnchor(null); }}>
                        <Typography style={{ fontSize: '13px' }}>{opt.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>

        </div>
    );
}
